import $ from 'jquery';
import debounce from 'debounce';

function setExpanded(e) {
  const $link = $(e.currentTarget);
  $link.attr('aria-expanded', true);
}

function unsetExpanded(e) {
  const $link = $(e.currentTarget);
  $link.attr('aria-expanded', false);
}

export default class MegaNavigation {
  constructor({ el }) {
    this.$el = $(el);
    this.initializedClass = 'navigation-initialized';

    this._bindEvents();
    this.timeouts = [];
    this._validate();
  }

  _bindEvents() {
    this.events = [
      $('.mobile-navigation-toggle', this.$el).on('click.meganav', event => this.toggleMobileNavigation(event)),
      $('.mobile-tier-toggle', this.$el).on('click.meganav', event => this.toggleMobileTier(event)),
      $('.has-chidren > a', this.$el).on('click.meganav', event => this.changeTier(event)),
      $('.mega-nav-breadcrumbs span', this.$el).on('click.meganav', event => this.previousTier(event)),
      $('.bacon-menu-button', this.$el).on('click.meganav', event => this.baconMenu(event)),
      $('[aria-haspopup]', this.$el).on('mouseenter.meganav', event => setExpanded(event)),
      $('[aria-haspopup]', this.$el).on('mouseleave.meganav', event => unsetExpanded(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.meganav'));
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    this.body = $(document.body);
    this.navigation = $('.navigation', this.$el);
    this.windowWidth = document.documentElement.clientWidth;
    this.checkDropdownWidth();

    if ($('li.mega-nav', this.$el).length) { this.prepareMegaNav(); }

    $(window).on('resize', () => {
      this.setWindowWidth();
      if ($('li.mega-nav', this.$el).length) { this.prepareMegaNav(); }
      if (this.navigation.hasClass('mobile-visible') && (this.windowWidth > 1020)) {
        this.navigation.removeClass('mobile-visible');
        this.resetHeights();
      }
    });
  }

  setWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth;
  }

  // Support for (Bacon Menu)[https://apps.shopify.com/bacon-menu]
  baconMenu(event) {
    const $linkItem = $(event.currentTarget);
    const $menuWrapper = $linkItem.parents('.tier-1');
    $menuWrapper.find('li').css('height', '');

    $('.bacon-menu-button.active', this.$el).each((index, element) => {
      const $current = $(element);

      if ($current.next('div').is(':hidden')) {
        $current.removeClass('active');
      }
    });
  }

  checkDropdownWidth() {
    $('.tier-1 > .has-dropdown', this.$el).each((index, item) => {
      const $item = $(item);

      if (!$item.hasClass('mega-nav')) {
        const itemOffset = $item.offset();

        if ($item.find('.tier-2').length && ((itemOffset.left + 200) > this.windowWidth)) {
          $item.addClass('alternate-drop');
        }

        if ($item.find('.tier-3').length && ((itemOffset.left + 400) > this.windowWidth)) {
          $item.addClass('alternate-drop');
        }
      }
    });
  }

  toggleMobileNavigation() {
    if (!this.navigation.hasClass('processed')) {
      $(window).on('resize', () => debounce(() => {
        if (this.windowWidth > 1020) { this.resetHeights(); }
      },
      500));

      this.navigation.addClass('processed');
    }

    const firstTier = $('.tier-1', this.$el);

    if (this.navigation.hasClass('mobile-visible')) {
      // Support for (Bacon Menu)[https://apps.shopify.com/bacon-menu]
      if (this.body.hasClass('bacon-menu-loaded')) {
        this.navigation.find('.bacon-menu-button.active').each((index, element) => {
          $(element).trigger('click');
        });
        this.navigation.find('.bacon-highway-mobile.active').each((index, element) => {
          $(element).trigger('click');
        });
      }

      this.navigation.removeClass('mobile-visible');
      this.resetHeights();
    } else {
      const height = this.getHiddenHeight(firstTier);
      firstTier.addClass('open');
      this.timeouts.push(setTimeout((() => {
        this.navigation.addClass('mobile-visible');
        $('.mobile-navigation-toggle', this.$el).addClass('active');
        firstTier.css('height', height);
      }
      ), 50));
    }
  }

  toggleMobileTier(e) {
    let height;
    e.preventDefault();
    e.stopPropagation();

    const parent = $(e.target).closest('.has-dropdown, .mega-nav, .mega-nav-item, .has-children');
    const list = parent.find('> ul');

    if (parent.hasClass('open')) {
      height = list.height();
      list.parents('ul')
        .css('height', `-=${height}`);
      list.find('.open')
        .removeClass('open')
        .find('> ul')
        .css('height', '');
      this.events.push(list.height(0).one('transitionend.meganav', () => parent.removeClass('open')));
    } else {
      height = this.getHiddenHeight(list);
      parent.addClass('open');
      list.css('height', height);
      list.parents('ul').css('height', `+=${height}`);
    }
  }

  getHiddenHeight(elem) {
    const temp = $(elem).clone().addClass('cloned-list').appendTo(this.navigation);

    const height = temp.height();
    temp.remove();
    return height;
  }

  resetHeights() {
    $('ul', this.$el).each((index, list) => {
      const $list = $(list);
      $list.parent('li').css('min-height', '');
      $list.css('min-height', '').css('height', '').parent().removeClass('open');
    });

    $('.mobile-navigation-toggle', this.$el).removeClass('active');
  }

  prepareMegaNav() {
    this.$el.toggleClass(this.initializedClass, true);

    this.megaNavDropdown = $('.mega-nav-dropdown', this.$el);

    if (this.windowWidth > 1020) {
      const navigationWidth = this.navigation.width();

      this.megaNavDropdown.css({
        width: navigationWidth,
        marginLeft: -(navigationWidth / 2),
      });
    } else {
      this.megaNavDropdown.css({
        top: '',
        width: '',
        marginLeft: '',
      });
    }
  }

  setMegaNav() {
    if (this.windowWidth < 1021) { return; }

    const firstTierHeight = this.megaNavDropdown.height();
    this.megaNavDropdown.data('first-tier-height', firstTierHeight).height(firstTierHeight);
  }

  resetMegaNav(e) {
    if (this.windowWidth < 1021) { return; }

    if (e && $(e.relatedTarget).closest('.mega-nav').length) { return; }

    this.megaNavDropdown.height(this.megaNavDropdown.data('first-tier-height'));
    $('.active', this.$el).removeClass('active');
  }

  changeTier(e) {
    if (this.windowWidth < 1021) { return; }

    e.preventDefault();

    $(e.currentTarget).addClass('working');

    const nextTier = $(e.currentTarget).next('ul');
    const nextTierHeight = nextTier.outerHeight();
    const currentHeight = this.megaNavDropdown.height();

    if (currentHeight < nextTierHeight) {
      this.megaNavDropdown.height(nextTierHeight);
    } else {
      nextTier.css({ bottom: 0 });
    }

    $(e.currentTarget).removeClass('working').addClass('active');
  }

  previousTier(e) {
    if ($(e.currentTarget).hasClass('current-tier')) { return; }

    if ($(e.currentTarget).hasClass('tier-1')) {
      $('.active', this.$el).removeClass('active');
      this.megaNavDropdown.height(this.megaNavDropdown.data('first-tier-height'));
    } else {
      $(e.currentTarget).closest('ul').siblings('.active').removeClass('active');
      const previousTierHeight = $(e.currentTarget).closest('.mega-nav-tier-2').outerHeight();
      this.megaNavDropdown.height(previousTierHeight);
    }

    if (!$('.active', this.$el).length) {
      this.resetMegaNav();
    }
  }

  onSectionUnload() {
    this._unbindEvents();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
